module.exports = __webpack_public_path__ + "static/16 - CU-4ce110daad348230723fadeda95f98d7.jpg";